import styled from 'styled-components'
import Paper from '../../Paper'

export const Container = styled(Paper)`
  padding: 0;
`
